import React from 'react'
import { bem } from '@argos/utils'
import PropTypes from 'prop-types'
import SliderToolTip from './SliderTooltip'

const cn = bem({ prefix: 'lc-', block: 'feedback-slider__container--progress' })

export class SliderHandle extends React.Component {
  static propTypes = {
    dragging: PropTypes.bool,
    dragStart: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  render() {
    const { dragStart, showToolTip, value } = this.props
    return (
      <div>
        <button type='button' className={cn('handle')} onMouseDown={dragStart} onTouchStart={dragStart} />
        {showToolTip && <SliderToolTip value={value} />}
      </div>
    )
  }
}
export default SliderHandle
